import styled from 'styled-components';
import { withModifiers } from 'utils';
import { color } from 'styles/settings';
import { ReactComponent as DeleteIcon } from 'styles/icons/delete-icon.svg';
import { ReactComponent as CheckIcon } from 'styles/icons/check-circle-filled.svg';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 400px;
  height: 380px;
  background-color: inherit;
  transition: background-color 0.2s;
  cursor: pointer;
  padding: 10px 40px 10px 40px;
  position: relative;
  box-sizing: border-box;
  margin-right: 10px;
  margin-bottom: 10px;

  @media all and (max-width: 1200px) {
    margin: auto;
  }

  ${withModifiers('selected')`
    background-color: ${color.neutral.grayLight};
  `};

  :hover {
    background-color: ${color.neutral.grayLight};
  }

  ${withModifiers('disabled')`
    opacity: 0.5;
    :hover {
       background-color: transparent;
    }
    cursor: disabled;
  `};
`;

export const DeselectButton = styled(DeleteIcon)`
  position: absolute;
  top: 20px;
  right: 20px;
  width: 26px;
  height: 26px;
`;

export const SelectedIcon = styled(CheckIcon)`
  position: absolute;
  bottom: 35px;
  right: 20px;
  width: 26px;
  height: 28px;
  color: ${color.brand.greenDark};
`;
